/* eslint-disable no-use-before-define */
import React from 'react';
import { render } from 'react-dom';
import Button, { outline } from '@narvar/nth-button';
import Spinner from '@narvar/nth-spinner';
import TextInput from '@narvar/nth-text-input';
import TextArea from '@narvar/nth-text-area';
import s from './blindReturnSidebar.module.css';
import ReturnsSidebar from '../../react-components/ReturnsSidebar/ReturnsSidebar';
import ButtonMenu from '../../react-components/ButtonMenu';
import SidebarSectionTitle from '../../react-components/SidebarSectionTitle/SidebarSectionTitle';

export const renderBlindSidebar = ({
  sidebarState,
  actions,
  disableNextSections,
  buildFormState,
  reasonSelected,
  checkRequiredFields,
  returnType,
  updateCallback,
  language,
  node,
}) => {
  const { currentItem, savedItems, config, open, loading, panel, returnReasons } = sidebarState;
  const currentPanel = config.panels[panel];
  const currentItemName = currentItem && currentItem.itemDescription;
  const selectedReason = currentItem && currentItem.selectedReason;
  const savedItem = savedItems[currentItemName];
  let previousRequiredValue;

  if (currentPanel.extendItems) {
    currentItem.extendItems = currentPanel.extendItems;
  }

  render(
    <div>
      <ReturnsSidebar
        title={currentPanel.title}
        toggleSide="right"
        sidebarOpen={open}
        closeIconOnClick={actions.toggle}
        overlayOnClick={actions.toggle}
      >
        {loading ? (
          <Spinner className={s.spinner} style={{ width: '4rem' }} />
        ) : (
          <div>
            {currentPanel.components.map((component, index) => {
              const { name, type, inputKey, required, defaultValue } = component;
              const requiredFieldsEmpty = disableNextSections(previousRequiredValue, name);
              buildFormState(component);

              if (requiredFieldsEmpty) {
                return null;
              }

              if (currentItem[previousRequiredValue]) {
                previousRequiredValue = null;
              }

              if (required) {
                previousRequiredValue = inputKey;
              }

              if (
                defaultValue &&
                !currentItem[inputKey] &&
                ['TextInput', 'CommentBox'].includes(name)
              ) {
                currentItem[inputKey] = defaultValue;
              }

              if (name === 'SectionTitle') {
                return (
                  <SidebarSectionTitle
                    index={index}
                    title={component.text}
                    disabled={!!previousRequiredValue}
                  />
                );
              } else if (name === 'TextInput') {
                return (
                  <TextInput
                    id={inputKey}
                    className={`sidebar-input ${currentItem[inputKey] ? 'filled-input' : ''}`}
                    name={inputKey}
                    label={component.placeholder}
                    onChange={actions.formChange}
                    type={type || 'text'}
                    defaultValue={currentItem[inputKey]}
                    maxLength={100}
                  />
                );
              } else if (name === 'CommentBox') {
                return (
                  <TextArea
                    id={inputKey}
                    className={`sidebar-comments ${currentItem[inputKey] ? 'filled-input' : ''}`}
                    style={{ width: '100%' }}
                    name={inputKey}
                    label={component.placeholder}
                    onChange={actions.formChange}
                    value={currentItem[inputKey]}
                  />
                );
              } else if (name === 'ButtonMenu') {
                return (
                  <ButtonMenu
                    menuItems={selectedReason ? [selectedReason] : returnReasons}
                    itemKey="return_reason_code_id"
                    propName="reason_category"
                    itemClick={selectedReason ? actions.resetReason : actions.selectReason}
                    checkSelected={reasonSelected}
                  />
                );
              }

              return null;
            })}

            <hr className={s.divider} />

            <Button
              className="narvar-btn-primary sidebar-done-button sidebar-action-btn"
              big
              disabled={checkRequiredFields()}
              onClick={() => {
                actions.saveItem();
                return returnType === 'simple_returns' ? updateCallback(true) : updateCallback();
              }}
            >
              {language['returns.step_1.sidepanel_next']}
            </Button>

            {!checkRequiredFields() ? (
              <Button
                className={`${returnType}-additional-items narvar-btn-secondary sidebar-additional-items-button sidebar-action-btn`}
                s={{ marginTop: '1rem', ...outline() }}
                big
                onClick={() => {
                  actions.saveItem();
                  updateCallback(true);
                }}
              >
                {language['returns.step_1.sidepanel_additional_items']}
              </Button>
            ) : null}

            {savedItem && savedItem.selected ? (
              <Button
                className="narvar-btn-secondary sidebar-cancel-item-button sidebar-action-btn"
                onClick={() => {
                  actions.deleteItem();
                  updateCallback(true);
                }}
                s={{ marginTop: '1rem' }}
                big
              >
                {language['returns.step_1.sidepanel_dont_return']}
              </Button>
            ) : null}
          </div>
        )}
      </ReturnsSidebar>
    </div>,
    node,
  );
};
